import { focusManager, QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnMount: false } },
});

// Time in ms when to refetch current active queries after the browser window has been inactive or hidden
const FOCUS_REFETCH_TIMEOUT = 1000 * 10;

focusManager.setEventListener((handleFocus) => {
  let blurTime: number;

  const onBlur = () => {
    blurTime = new Date().getTime();
    handleFocus(false);
  };

  const onFocus = () => {
    if (new Date().getTime() - blurTime > FOCUS_REFETCH_TIMEOUT) {
      handleFocus(true);
    }
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener('focus', onFocus, false);
    window.addEventListener('blur', onBlur, false);
  }

  return () => {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    }
  };
});

export default queryClient;
